import { Col, Form, Row } from 'antd';
import React from 'react';

function FileUploadLarge() {
  return (
    <Form layout="horizontal" labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
      <Row gutter={[0, 24]}>
        <Col span={24}>FileUploadLarge</Col>
      </Row>
    </Form>
  );
}

export default FileUploadLarge;
